<div class="notification-card">

  <!-- 🔙 HEADER : titre + bouton retour -->
  <div class="notification-header">
      <button
      pButton
      type="button"
      icon="pi pi-arrow-left"
      label="Retour à la liste"
      class="p-button-sm p-button-secondary"
      (click)="goToList()"
    ></button>
    <div class="notification-title">
      ⏰ Notification programmée
    </div>

  
  </div>

  <!-- Messages -->
  <div class="alert alert-success" *ngIf="successMessage">
    {{ successMessage }}
  </div>

  <div class="alert alert-danger" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <!-- FORM -->
  <div class="form-grid">

    <!-- Title -->
    <div class="form-group">
      <label>Titre *</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="form.title"
        placeholder="Ex: Points doublés 🔥"
      />
    </div>

    <!-- Description -->
    <div class="form-group">
      <label>Description *</label>
      <textarea
        class="form-control"
        rows="3"
        [(ngModel)]="form.description"
      ></textarea>
    </div>

    <!-- Days -->
    <div class="days-wrapper">
      <label class="days-title">Jours d’envoi</label>

      <div class="days-buttons">
        <button
          *ngFor="let day of days"
          type="button"
          [ngStyle]="{
            margin: '6px',
            background: form.daysOfWeek.includes(day.value) ? '#ffa500' : '#fff',
            color: form.daysOfWeek.includes(day.value) ? '#fff' : '#000',
            border: '1px solid #000',
            padding: '12px'
          }"
          (click)="toggleDays(day.value)"
        >
          {{ day.label }}
        </button>
      </div>
    </div>

    <!-- Unlimited -->
    <div class="form-group">
      <label>
        <input type="checkbox" [(ngModel)]="form.isUnlimitedTime" />
        Notification immédiate (sans limite de temps)
      </label>
    </div>

    <!-- Planning -->
    <div *ngIf="!form.isUnlimitedTime">
      <div class="form-group">
        <label>Heure de début</label>
        <input type="time" class="form-control" [(ngModel)]="form.startTime" />
      </div>

      <div class="form-group">
        <label>Heure de fin</label>
        <input type="time" class="form-control" [(ngModel)]="form.endTime" />
      </div>

      <div class="form-group">
        <label>Intervalle (minutes)</label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="form.intervalMinutes"
          placeholder="Ex: 120"
        />
      </div>
    </div>

    <!-- Submit -->
    <button class="btn btn-primary" (click)="submit()" [disabled]="loading">
      {{ loading ? 'Envoi...' : 'Créer la notification' }}
    </button>

  </div>
</div>
